import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { Award, Clock, CheckCircle2, EyeOff } from "lucide-react";

export default function StudentResults() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/exam/my-attempts").then((r) => setItems(r.data || [])); }, []);

  return (
    <DashboardLayout>
      <h1 className="heading text-2xl font-bold">My Results</h1>
      <p className="text-sm text-slate-500 mt-1">Results are published by Admin. You will see your score here once released.</p>
      {items.length === 0 ? (
        <div className="mt-8 p-14 rounded-2xl border border-dashed border-slate-300 text-center">
          <Award size={40} className="mx-auto text-slate-300" />
          <div className="mt-3 text-slate-500">You haven't attempted any exam yet.</div>
        </div>
      ) : (
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          {items.map((a) => (
            <div key={a.id} className="p-6 rounded-2xl border border-slate-200 bg-white" data-testid={`result-card-${a.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="heading text-lg font-bold">{a.test_title}</h3>
                  <div className="text-xs text-slate-500 mt-1 flex items-center gap-1">
                    <Clock size={12} /> Submitted {a.submitted_at ? new Date(a.submitted_at).toLocaleString() : "—"}
                  </div>
                </div>
                {a.is_result_published ? (
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-emerald-100 text-emerald-700 px-2 py-1 rounded flex items-center gap-1">
                    <CheckCircle2 size={12} /> Declared
                  </span>
                ) : (
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-amber-100 text-amber-700 px-2 py-1 rounded flex items-center gap-1">
                    <EyeOff size={12} /> Awaiting
                  </span>
                )}
              </div>
              <div className="mt-5 p-4 rounded-xl bg-slate-50">
                {a.is_result_published ? (
                  <>
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Score</div>
                    <div className="heading text-3xl font-bold text-brand mt-1">{a.score} / {a.total}</div>
                    <div className="text-xs text-slate-500 mt-1">{Math.round((a.score / Math.max(a.total, 1)) * 100)}%</div>
                  </>
                ) : (
                  <div className="text-sm text-slate-600">🕐 Your result will be announced by Admin. Please check back later.</div>
                )}
              </div>
              {a.violations_count > 0 && (
                <div className="mt-3 text-xs text-red-600">⚠ Violations logged: {a.violations_count}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
